// import React, { useEffect, useState } from 'react';

// // Helper function to get the week number of the year
// function getWeekNumber(date) {
//   const start = new Date(date.getFullYear(), 0, 1);
//   const diff = date - start;
//   const oneDay = 1000 * 60 * 60 * 24;
//   return Math.ceil(diff / oneDay / 7);
// }

// function MyMapComponent() {
//   const [zipData, setZipData] = useState([]);
//   const [buttonDisabled, setButtonDisabled] = useState(false);
//   const [buttonText, setButtonText] = useState('Run Automation');
//   const [automationData, setAutomationData] = useState({
//     runsThisWeek: 0,
//     lastRunDate: null,
//   });
//   const [userRole, setUserRole] = useState("");

//   // Fetch initial data including user role, map data, and automation data
//   useEffect(() => {
//     // Set user role from localStorage
//     const role = localStorage.getItem("role");
//     setUserRole(role);

//     // Fetch map data
//     fetch("/api/map_data", {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         'Cache-Control': 'no-cache',
//       }
//     })
//       .then(res => res.json())
//       .then(data => {
//         setZipData(data);
//       })
//       .catch(err => {
//         console.error("Error fetching map data", err);
//       });

//     // Fetch automation data
//     fetch("/api/get-automation-data", {
//       method: 'GET',
//       headers: {
//         'Authorization': `Bearer ${localStorage.getItem('token')}`,
//         'Content-Type': 'application/json',
//       }
//     })
//       .then(res => res.json())
//       .then(data => {
//         setAutomationData(data);
//         const currentWeek = getWeekNumber(new Date());
//         if (data.lastRunDate && getWeekNumber(new Date(data.lastRunDate)) === currentWeek) {
//           if (data.runsThisWeek >= 10) {
//             setButtonDisabled(true);
//             setButtonText("Limit Reached");
//           }
//         } else {
//           localStorage.setItem("runsThisWeek", 0);
//           setButtonDisabled(false);
//           setButtonText("Run Automation");
//         }
//       })
//       .catch(err => {
//         console.error("Error fetching automation data", err);
//       });
//   }, []);

//   const handleRunAutomation = async () => {
//     try {
//       const runsThisWeek = parseInt(localStorage.getItem("runsThisWeek") || 0);
//       if (runsThisWeek >= 10) {
//         alert('You have already run the automation 2 times this week.');
//         return;
//       }

//       // Call Flask API to trigger the automation
//       await fetch("/api/run-automation", {
//         method: 'POST',
//       });

//       // Prepare the updated data with incremented run count
//       const updatedData = {
//         runsThisWeek: runsThisWeek + 1,
//         lastRunDate: new Date().toISOString(),
//       };

//       const response = await fetch("/api/update-automation-data", {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('token')}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(updatedData),
//       });

//       const data = await response.json();

//       if (data.message === "Automation data updated successfully!") {
//         // Update localStorage with the new run count
//         localStorage.setItem("runsThisWeek", runsThisWeek + 1);
//         // Re-fetch automation data to ensure state sync
//         fetch("/api/get-automation-data", {
//           method: 'GET',
//           headers: {
//             'Authorization': `Bearer ${localStorage.getItem('token')}`,
//             'Content-Type': 'application/json',
//           }
//         })
//           .then(res => res.json())
//           .then(data => {
//             setAutomationData(data);
//             if (data.runsThisWeek >= 2) {
//               setButtonDisabled(true);
//               setButtonText("Limit Reached");
//             }
//           });
//         alert('Automation started!');
//       }
//     } catch (error) {
//       console.error("Error running automation:", error);
//       alert('Failed to run automation');
//     }
//   };

//   useEffect(() => {
//     if (zipData.length === 0) return;

//     // Check if the script is already added to avoid multiple script inserts
//     if (!document.getElementById("google-maps-script")) {
//       const script = document.createElement('script');
//       script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAeUgbmW8fb_p1Qz5oUyhlnYdrG-9-OeNA&v=beta&libraries=marker&callback=initMap`;
//       script.id = "google-maps-script";
//       script.async = true;
//       script.defer = true;
//       document.body.appendChild(script);
//     }

//     window.initMap = function () {
//       const center = { lat: 37.0902, lng: -95.7129 };
//       const map = new window.google.maps.Map(document.getElementById("map"), {
//         zoom: 4,
//         center: center,
//       });
    
//       const bounds = new window.google.maps.LatLngBounds();
//       zipData.forEach(data => {
//         const position = { lat: data.latitude, lng: data.longitude };
    
//         const marker = new window.google.maps.Marker({
//           position: position,
//           map: map,
//           title: `Zip: ${data.zip}`,
//         });
//         bounds.extend(position);
    
//         const infoWindowContent = `
//           <div style="max-width: 300px; padding: 15px; background-color: #fff; border-radius: 10px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
//             <h3 style="margin: 10px 0;">Zip Code: ${data.zip}</h3>
//             <p style="font-size: 14px; color: #555;">This is a custom designed card with more information about this location.</p>
//             <a href="${data.link}" target="_blank" style="text-decoration: none; color: #007BFF;">Visit Location</a>
//           </div>
//         `;
    
//         const infoWindow = new window.google.maps.InfoWindow({
//           content: infoWindowContent,
//         });
    
//         marker.addListener("click", () => {
//           infoWindow.open(map, marker);
//         });
//       });
    
//       map.fitBounds(bounds);
//     };

//     return () => {
//       const script = document.getElementById("google-maps-script");
//       if (script) {
//         document.body.removeChild(script);
//       }
//     };
//   }, [zipData]);

//   return (
//     <div style={{ textAlign: 'center' }}>
//       {userRole === "owner" && (
//         <div style={{ marginBottom: '20px' }}>
//           <button
//             onClick={handleRunAutomation}
//             disabled={buttonDisabled}
//             style={{
//               padding: '10px 20px',
//               fontSize: '16px',
//               backgroundColor: buttonDisabled ? 'red' : '#4CAF50',
//               color: buttonDisabled ? 'white' : '#FFF',
//               border: 'none',
//               borderRadius: '5px',
//               cursor: buttonDisabled ? 'not-allowed' : 'pointer',
//               width: '200px',
//               transition: 'all 0.3s ease',
              
//             }}
//           >
//             {buttonText}
//           </button>
//         </div>
//       )}
//       <div id="map" style={{ width: '100%', height: '600px' }}></div>
//     </div>
//   );
  
// }

// export default MyMapComponent;




























import React, { useEffect, useState } from 'react';

// Helper function to get the week number of the year
function getWeekNumber(date) {
  const start = new Date(date.getFullYear(), 0, 1);
  const diff = date - start;
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.ceil(diff / oneDay / 7);
}

function MyMapComponent() {
  const [zipData, setZipData] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [buttonText, setButtonText] = useState('Run Automation');
  const [automationData, setAutomationData] = useState({
    runsThisWeek: 0,
    lastRunDate: null,
  });
  const [userRole, setUserRole] = useState("");
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';

  // Fetch initial data including user role, map data, and automation data
  useEffect(() => {
    // Set user role from localStorage
    const role = localStorage.getItem("role");
    setUserRole(role);

    // Fetch map data
    fetch(`${backendUrl}/api/map_data`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
      mode: 'cors',
    })
      .then(res => res.json())
      .then(data => {
        setZipData(data);
      })
      .catch(err => {
        console.error("Error fetching map data", err);
      });

    // Fetch automation data
    fetch(`${backendUrl}/api/get-automation-data`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      }
    })
      .then(res => res.json())
      .then(data => {
        setAutomationData(data);
        const currentWeek = getWeekNumber(new Date());
        if (data.lastRunDate && getWeekNumber(new Date(data.lastRunDate)) === currentWeek) {
          if (data.runsThisWeek >= 10) {
            setButtonDisabled(true);
            setButtonText("Limit Reached");
          }
        } else {
          localStorage.setItem("runsThisWeek", 0);
          setButtonDisabled(false);
          setButtonText("Run Automation");
        }
      })
      .catch(err => {
        console.error("Error fetching automation data", err);
      });
  }, []);

  const handleRunAutomation = async () => {
    try {
      const runsThisWeek = parseInt(localStorage.getItem("runsThisWeek") || 0);
      if (runsThisWeek >= 10) {
        alert('You have already run the automation 2 times this week.');
        return;
      }

      // Call Flask API to trigger the automation
      await fetch(`${backendUrl}/api/run-automation`, {
        method: 'POST',
      });

      // Prepare the updated data with incremented run count
      const updatedData = {
        runsThisWeek: runsThisWeek + 1,
        lastRunDate: new Date().toISOString(),
      };

      const response = await fetch(`${backendUrl}/api/update-automation-data`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });

      const data = await response.json();

      if (data.message === "Automation data updated successfully!") {
        // Update localStorage with the new run count
        localStorage.setItem("runsThisWeek", runsThisWeek + 1);
        // Re-fetch automation data to ensure state sync
        fetch(`${backendUrl}/api/get-automation-data`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          }
        })
          .then(res => res.json())
          .then(data => {
            setAutomationData(data);
            if (data.runsThisWeek >= 2) {
              setButtonDisabled(true);
              setButtonText("Limit Reached");
            }
          });
        alert('Automation started!');
      }
    } catch (error) {
      console.error("Error running automation:", error);
      alert('Failed to run automation');
    }
  };

  useEffect(() => {
    if (zipData.length === 0) return;

    // Check if the script is already added to avoid multiple script inserts
    if (!document.getElementById("google-maps-script")) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAeUgbmW8fb_p1Qz5oUyhlnYdrG-9-OeNA&v=beta&libraries=marker&callback=initMap`;
      script.id = "google-maps-script";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    window.initMap = function () {
      const center = { lat: 37.0902, lng: -95.7129 };
      const map = new window.google.maps.Map(document.getElementById("map"), {
        zoom: 4,
        center: center,
      });
    
      const bounds = new window.google.maps.LatLngBounds();
      zipData.forEach(data => {
        const position = { lat: data.latitude, lng: data.longitude };
    
        const marker = new window.google.maps.Marker({
          position: position,
          map: map,
          title: `Zip: ${data.zip}`,
        });
        bounds.extend(position);
    
        const infoWindowContent = `
          <div style="max-width: 300px; padding: 15px; background-color: #fff; border-radius: 10px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
            <h3 style="margin: 10px 0;">Zip Code: ${data.zip}</h3>
            <p style="font-size: 14px; color: #555;">This is a custom designed card with more information about this location.</p>
            <a href="${data.link}" target="_blank" style="text-decoration: none; color: #007BFF;">Visit Location</a>
          </div>
        `;
    
        const infoWindow = new window.google.maps.InfoWindow({
          content: infoWindowContent,
        });
    
        marker.addListener("click", () => {
          infoWindow.open(map, marker);
        });
      });
    
      map.fitBounds(bounds);
    };

    return () => {
      const script = document.getElementById("google-maps-script");
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [zipData]);

  return (
    <div style={{ textAlign: 'center' }}>
      {userRole === "owner" && (
        <div style={{ marginBottom: '20px' }}>
          <button
            onClick={handleRunAutomation}
            disabled={buttonDisabled}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: buttonDisabled ? 'red' : '#4CAF50',
              color: buttonDisabled ? 'white' : '#FFF',
              border: 'none',
              borderRadius: '5px',
              cursor: buttonDisabled ? 'not-allowed' : 'pointer',
              width: '200px',
              transition: 'all 0.3s ease',
              
            }}
          >
            {buttonText}
          </button>
        </div>
      )}
      <div id="map" style={{ width: '100%', height: '600px' }}></div>
    </div>
  );
  
}

export default MyMapComponent;

